// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3MMzY","list":"styles_list__31MEu"};